import './index.less';
import React from 'react';
import { PluginType, type IExportPlugin } from '@/version-types';
import { BaseOperateView, BaseStagePlugin } from '../../components';
import { useActiveFrameIndex, useFramework, useLayerTranslate, useShineMap } from '../../hooks';

const ShineItem: React.FC<{ layerId: string }> = React.memo(({ layerId }) => {
    const framework = useFramework();
    useLayerTranslate(layerId);
    const layer = framework.service.flatLayer.getLayer(layerId);

    if (!layer) return null;

    return (
        <BaseOperateView layer={layer}>
            <div className="c-layer-shine"></div>
        </BaseOperateView>
    );
});

const LayerShineView = React.memo(() => {
    const framework = useFramework();
    const shineMap = useShineMap();

    const activeStageIndex = useActiveFrameIndex();
    const list = Array.from(shineMap).filter((layerId) => {
        const isSingleMode = framework.service.edgelessCanvas.isSingleMode;
        if (!isSingleMode) {
            return true;
        }
        const originIndex = framework.service.frame.getLayerFrameId(layerId);
        return originIndex === framework.service.frame.indexToFrameId(activeStageIndex);
    });

    if (list.length === 0) return null;

    return (
        <BaseStagePlugin style={{ zIndex: 1 }} name="layer-shine">
            {list.map((layerId) => {
                return <ShineItem key={layerId} layerId={layerId} />;
            })}
        </BaseStagePlugin>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 20,
    name: 'layer-shine',
    render() {
        return <LayerShineView />;
    },
};

export default exportPlugin;
